import * as React from 'react';
import { RenovationsAndClosuresViewModel } from 'models';
import { PropertyDetailsSegment } from './property-details-segment';

interface RenovationsAndClosuresProps {
  renovationsAndClosuresDescription?: RenovationsAndClosuresViewModel;
}

export const RenovationsAndClosures: React.FunctionComponent<RenovationsAndClosuresProps> = ({ renovationsAndClosuresDescription }) =>
  Boolean(renovationsAndClosuresDescription) && (
    <PropertyDetailsSegment
      dataStid="section-renovations-and-closures"
      errorBoundaryLabel="hotel.information.details.renovationsAndClosures"
      rootClassName="renovations-and-closures"
      title={renovationsAndClosuresDescription.title}
      isToggleHidden={true}
    >
      <div
        data-stid="renovations-and-closures-text"
        className="all-y-padding-three uitk-type-list-300"
        dangerouslySetInnerHTML={{ __html: renovationsAndClosuresDescription.text }}
      />
    </PropertyDetailsSegment>
  );
